// Light or dark. Until someone picks one, the panel follows the system
// (styles.css does that on its own); a pick is kept in localStorage and set
// as <html data-theme="...">. public/index.html applies a saved pick before
// the first paint, so the page doesn't flash the other theme.
export const THEME_KEY = "qrt_theme";

export function currentTheme() {
  const chosen = document.documentElement.dataset.theme;
  if (chosen === "light" || chosen === "dark") return chosen;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function setTheme(theme) {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    // Private window or storage blocked: the pick lasts until the page closes
  }
}
